import { DOCUMENT } from "@angular/common";
import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { Page } from "src/app/util/page";
import { AccessToken } from "../model/access-token";
import { CompanyDetails } from "../model/company-details";
import { Synchronization } from "../model/synchronization";
import { QuickbookService } from "../quickbook-service";

@Component({
  selector: "quickbook-overview",
  styleUrls: ["./quickbook-overview.component.css"],
  templateUrl: "./quickbook-overview.component.html"
})
export class QuickbookOverviewComponent {
  @ViewChild('modal') modalRef!: ElementRef;

  accessToken!: AccessToken;
  noToken = false;
  companyDetails!: CompanyDetails;
  errorToDisplay!: string;

  renewalRequired!: boolean;

  synchronizationsPage!: Page<Synchronization>;
  lastSynchronization!: Synchronization | null;

  synchronizationsPageIndex = 0;
  synchronizationsPageSort = "startTimestamp,DESC";

  location: string;
  oauth2Url!: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private quickbookService: QuickbookService,
    private modalService: NgbModal,
  ) {
    this.location = document.location.href;

    quickbookService.getCompanyDetails()
      .pipe(tap(companyDetails => this.companyDetails = companyDetails))
      .pipe(tap(_ => this.computeUrl()))
      .subscribe();

    this.refreshSynchronizations().subscribe();
  }

  private computeUrl() {
    this.oauth2Url = this.companyDetails.authorizationUrl + `?client_id=${this.companyDetails.clientId}` +
      `&scope=com.intuit.quickbooks.accounting%20openid%20profile%20email%20phone%20address` +
      `&redirect_uri=${this.companyDetails.redirectUrl}` +
      `&response_type=code&state=${this.document.location.href}`;
  }

  getTokens() {
    this.document.location.href = this.oauth2Url;
  }

  isTokenExpired() {
    if (this.accessToken == undefined) {
      return false;
    }

    if (this.accessToken.refreshTokenExpiration == undefined) {
      return true;
    }

    return new Date(this.accessToken.refreshTokenExpiration).getTime() < new Date().getTime();
  }

  openErrorMessage(errorToDisplay: string) {
    this.errorToDisplay = errorToDisplay;

    this.modalService.open(this.modalRef, {
      size: "xl"
    });
  }

  startNewSynchronization() {
    this.quickbookService.startNewSynchronization()
      .pipe(switchMap(_ => this.refreshSynchronizations()))
      .subscribe();
  }

  private refreshSynchronizations(): Observable<Page<Synchronization>> {
    return this.quickbookService.findAccessToken()
      .pipe(tap(accessToken => this.accessToken = accessToken || new AccessToken()))
      .pipe(switchMap(_ => this.quickbookService.findAllSynchronizations(this.synchronizationsPageIndex, this.synchronizationsPageSort)))
      .pipe(tap(page => this.synchronizationsPage = page))
      .pipe(tap(_ => this.lastSynchronization = this.synchronizationsPage.content.length > 0 ? this.synchronizationsPage.content[0] : null))
      .pipe(tap(_ => setTimeout(() => this.refreshSynchronizations().subscribe(), 5000)));
  }
}